
import React, { useState } from 'react';
import { CustomDialog } from "../../../components/customDialog/CustomDialog";
import { RenderInputsRowByType } from '../../../components/formGroupGenerator/RenderInputRowByType';

export const GenerarRIInput = ({ loadingOthersButtons, handleClickAceptar }) => {
    const [openModal, setOpenModal] = useState(false);

    const handleOpenModal = () => setOpenModal(true);
    const handleClose = () => setOpenModal(false);

    const handleAccept = () => {
        // agregar la logica del cambio de programa
        handleClickAceptar();
    }

    return (
        <>
            <RenderInputsRowByType
                input={{
                    displayName: 'Generar RI',
                    name: 'generarRI',
                    type: 'button',
                    isLoading: loadingOthersButtons,
                    variant: 'outlined',
                    col: 30,
                    onClick: () => handleOpenModal()
                }}
                value={null}
                handleChange={null}
            />
            <CustomDialog
                maxWidth='sm'
                fullWidth
                onCancel={() => handleClose()}
                onAccept={() => { setOpenModal(false); handleAccept() }}
                open={openModal}
                cancelText='Cancelar'
                acceptText='Aceptar'
                title={'¿Está seguro que desea iniciar el flujo de RI?'}
            >

            </CustomDialog>
        </>
    );
}
